import React, { useState } from "react";
import IframeEmbed from "./IframeEmbed";
import WaterMark from "../../components/WaterMark";
import Loader from "../../components/Loader/Loader";

const Vas = () => {
  const baseUrl = process.env.REACT_APP_CUSTOMER_INSIGHT_URL;

  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");

  const url = `${baseUrl}?token=${encodeURIComponent(
    token
  )}&username=${encodeURIComponent(username)}`;

  const [loading, setLoading] = useState(true);

  return (
    <div>
      <WaterMark />

      {loading && (
        <div className="flex items-center justify-center h-screen">
          <Loader />
        </div>
      )}

      <div style={{ height: "80vh", display: loading ? "none" : "block" }}>
        <IframeEmbed
          url={url}
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );
};

export default Vas;
